import { useEffect, useState } from "react"

/**
 * @param {any} initialValue
 * @param {number} delay
 */
export function useDebounce(initialValue, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(initialValue)

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(initialValue)
    }, delay)

    return () => clearTimeout(timer)
  }, [initialValue, delay])

  return debouncedValue
}
